// SPDX-License-Identifier: Apache-2.0

import { jsonMember, jsonObject } from "typedjson";
import PerunMessage from "./PerunMessage";
import ChannelState from "./types/channelState";
import { MessageType, MessageTypeName } from "./messageTypes";
import Address from "./types/address";

@jsonObject
export default class ChannelInfo extends PerunMessage {
  @jsonMember(Address) peerAddressEth: Address;
  @jsonMember(String) peerAddressCC: string;
  @jsonMember(ChannelState) state: ChannelState;

  constructor(
    peerAddressEth: Address,
    peerAddressCC: string,
    state: ChannelState,
  ) {
    super();
    this.peerAddressEth = peerAddressEth;
    this.peerAddressCC = peerAddressCC;
    this.state = state;
  }

  messageType(): MessageType {
    return ChannelInfo;
  }

  messageTypeName(): MessageTypeName {
    return "ChannelInfo";
  }
}
